module.exports = __webpack_public_path__ + "img/returns.46202138.svg";